import Vector from "victor";
import Rect from "../types/Rect";
import { SimpleShape2 } from "./StandardShapes";
import CanvasBasedDOMRepresentation from "../CanvasBasedDOMRepresentation";
import Camera from "../Camera";
import { ShapeWithCanvasBasedDOMRepresentation2 } from "../types/Shape";
import { ShapeType } from "@/wbcontroller/types/ShapeType";
import { shapeScale2, shapeTruePosition2 } from "@/wbcontroller/util";
import {
  DiamondRenderer,
  DummyShapeRenderer,
  EllipseRenderer,
  LineRenderer,
  RectRenderer,
  StandardShapeRenderer,
} from "./StandardShapeRenderers";
import { RenderConfig } from "@/store/modules/toolConfig";

export class StandardShapeDOMRepresentation extends CanvasBasedDOMRepresentation {
  private renderer: StandardShapeRenderer;

  constructor(
    id: string,
    public shape: ShapeWithCanvasBasedDOMRepresentation2,
    transformEl: HTMLElement,
    camera: Camera,
    renderConfig: RenderConfig,
    shouldDraw = true
  ) {
    super(id, shape, transformEl, camera);

    switch (shape.shapeType) {
      case ShapeType.Diamond:
        this.renderer = new DiamondRenderer();
        break;
      case ShapeType.Ellipse:
        this.renderer = new EllipseRenderer();
        break;
      case ShapeType.Line:
        this.renderer = new LineRenderer(renderConfig);
        break;
      case ShapeType.Rect:
        this.renderer = new RectRenderer();
        break;
      case ShapeType.Node:
      case ShapeType.Eraser:
      case ShapeType.Pen:
      case ShapeType.Text:
        this.renderer = new DummyShapeRenderer();
        break;
    }

    if (shouldDraw) {
      this.redraw();
    }
  }

  drawShape(ctx: CanvasRenderingContext2D) {
    this.renderer.draw(ctx, this.shape);
  }

  get standardShape(): SimpleShape2 {
    return this.shape as unknown as SimpleShape2;
  }

  get selectionRect(): Rect {
    const shape = this.standardShape;
    const origin = shapeTruePosition2(shape);
    const scale = new Vector(1, 1).divide(shapeScale2(shape));
    const a = origin
      .clone()
      .add(Vector.fromArray(shape.pointA).multiply(scale));
    const b = origin
      .clone()
      .add(Vector.fromArray(shape.pointB).multiply(scale));
    return new Rect(a, b);
  }
}
